// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import { useStyles } from "./Styles";
import "../../../../index.scss";
import Header from "../../../Layout/Header/Header";
import Sider from "../../../Layout/Sider/Sider";
import axios from "axios";
import {
  getAll,
  patch,
  patchData,
  post,
} from "../../../../Services/GenericApiService";
import { useTranslation } from "react-i18next";
import AlertM from "../../../Helpers/AlertM/AlertM";
import { log } from "../../../../Services/LoggerService";
import VideoLikeMediaPlayer from "../VideoLikeMediaPlayer/VideoLikeMediaPlayer";

import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Skeleton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Grid,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Card,
  CardContent,
  Avatar,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Tooltip,
  ButtonGroup,
  Stack,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  getLoggedInUserRole,
  getUserData,
} from "../../../../Services/LocalStorageService";

// font awesome stuff
const iconList = Object.keys(Icons)
  .filter((key) => key !== "fas" && key !== "prefix")
  .map((icon) => Icons[icon]);

library.add(...iconList);

// Islamic Text Shortcuts
const ISLAMIC_PHRASES = {
  saww: {
    arabic: "ﷺ",
    transliteration: "صلى الله عليه وسلم",
    english: "(Peace be upon him)",
    description: "For Prophet Muhammad",
  },
  as: {
    arabic: "عليه السلام",
    transliteration: "عليه السلام",
    english: "(Peace be upon him)",
    description: "For other Prophets",
  },
  ra: {
    arabic: "رضي الله عنه",
    transliteration: "رضي الله عنه",
    english: "(May Allah be pleased with him)",
    description: "For male Companions",
  },
  raFemale: {
    arabic: "رضي الله عنها",
    transliteration: "رضي الله عنها",
    english: "(May Allah be pleased with her)",
    description: "For female Companions",
  },
  swt: {
    arabic: "سبحانه وتعالى",
    transliteration: "سبحانه وتعالى",
    english: "(Glory be to Him, the Exalted)",
    description: "For Allah",
  },
  bismillah: {
    arabic: "بسم الله الرحمن الرحيم",
    transliteration: "بسم الله الرحمن الرحيم",
    english: "In the name of Allah, the Most Gracious, the Most Merciful",
    description: "Bismillah",
  },
  alhamdulillah: {
    arabic: "الحمد لله",
    transliteration: "الحمد لله",
    english: "All praise is for Allah",
    description: "Alhamdulillah",
  },
  subhanallah: {
    arabic: "سبحان الله",
    transliteration: "سبحان الله",
    english: "Glory be to Allah",
    description: "Subhanallah",
  },
  allahuakbar: {
    arabic: "الله أكبر",
    transliteration: "الله أكبر",
    english: "Allah is the Greatest",
    description: "Allahu Akbar",
  },
  astaghfirullah: {
    arabic: "أستغفر الله",
    transliteration: "أستغفر الله",
    english: "I seek forgiveness from Allah",
    description: "Astaghfirullah",
  },
  inshallah: {
    arabic: "إن شاء الله",
    transliteration: "إن شاء الله",
    english: "If Allah wills",
    description: "Insha Allah",
  },
  mashallah: {
    arabic: "ما شاء الله",
    transliteration: "ما شاء الله",
    english: "What Allah has willed",
    description: "Masha Allah",
  },
  barakallahu: {
    arabic: "بارك الله",
    transliteration: "بارك الله",
    english: "May Allah bless",
    description: "Barakallahu",
  },
};

function ContentVerificationMain() {
  // css for module
  const classes = useStyles();

  // translation
  const { t } = useTranslation();

  // child ref for alert
  const notifications = useRef();
  const textFieldRef = useRef();

  // module(s) for api
  const moduleMain = "islaminfocontentcheck";

  // Get the user's role from Redux store
  const userRole = getLoggedInUserRole();
  const studentId = process.env.REACT_APP_STUDENT_ROLE_ID;
  const teacherId = process.env.REACT_APP_TEACHER_ROLE_ID;
  const isStudent = userRole === studentId;
  const isTeacher = userRole === teacherId;

  // data vars
  const [allData, setAllData] = useState([]);
  const [dataToReview, setDataToReview] = useState(null);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [editedText, setEditedText] = useState("");
  const [editedConventionalId, setEditedConventionalId] = useState("");
  const [editedHadithStatus, setEditedHadithStatus] = useState("sahih");
  const [comments, setComments] = useState("");
  const [status, setStatus] = useState("approved");
  const [isSaving, setIsSaving] = useState(false);
  const [isSavingText, setIsSavingText] = useState(false);
  const [isSavingConventionalId, setIsSavingConventionalId] = useState(false);
  const [isSavingHadithStatus, setIsSavingHadithStatus] = useState(false);
  const [filters, setFilters] = useState({
    language: "",
    bookId: "",
  });
  const [languages, setLanguages] = useState([]);
  const [books, setBooks] = useState([]);

  // New states for audio generation and media player
  const [isGeneratingAudio, setIsGeneratingAudio] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [isMediaPlayerOpen, setIsMediaPlayerOpen] = useState(false);
  const [audioText, setAudioText] = useState("");

  // ui controls
  const [loading, setLoading] = useState(true);

  // table ui controls
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);

  const columns = [
    {
      name: "ID",
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return allData[dataIndex].id;
        },
      },
    },
    {
      name: "System ID",
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          const item = allData[dataIndex];
          return item?.hadithId || "N/A";
        },
      },
    },
    {
      name: "Hadith Book",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const item = allData[dataIndex];
          return item?.Hadiths?.book?.name || "N/A";
        },
      },
    },
    {
      name: "Conventional ID",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const item = allData[dataIndex];
          return item?.Hadiths?.conventionalId || item?.conventionalId || "N/A";
        },
      },
    },
    {
      name: "Language",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const item = allData[dataIndex];
          return item?.language || "N/A";
        },
      },
    },
    {
      name: "Hadith Status",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const item = allData[dataIndex];
          const hadithStatus = item?.Hadiths?.status || "sahih";

          return (
            <Chip
              label={hadithStatus === "sahih" ? "Sahih" : "Zaeef"}
              color={hadithStatus === "sahih" ? "success" : "warning"}
              size="small"
              icon={
                <FontAwesomeIcon
                  icon={
                    hadithStatus === "sahih"
                      ? "check-circle"
                      : "exclamation-triangle"
                  }
                />
              }
            />
          );
        },
      },
    },
    {
      name: "Approval Status",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const item = allData[dataIndex];
          const status = isStudent
            ? item.studentApprovalStatus
            : item.teacherApprovalStatus;

          let color = "default";
          if (status === "approved") color = "success";
          if (status === "rejected") color = "error";
          if (status === "pending") color = "warning";

          return <Chip label={status} color={color} size="small" />;
        },
      },
    },
    {
      name: "Preview",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const item = allData[dataIndex];
          return item.translation
            ? item.translation.substring(0, 50) + "..."
            : "No content";
        },
      },
    },
    {
      name: "Actions",
      options: {
        filter: false,
        sort: false,
        empty: true,
        setCellHeaderProps: () => {
          return { align: "right" };
        },
        setCellProps: () => ({
          align: "right",
        }),
        customBodyRenderLite: (dataIndex) => {
          return (
            <div className="d-inline-flex">
              <div className="px-2">
                <Tooltip title={t("common.review")}>
                  <IconButton
                    aria-label="review"
                    size="small"
                    onClick={() => handleReviewClick(dataIndex)}
                  >
                    <FontAwesomeIcon className="review-btn" icon="eye" />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          );
        },
      },
    },
  ];

  // fetch all languages and books for filtering
  const fetchFilterOptions = () => {
    getAll("language")
      .then((res) => {
        setLanguages(res.rows || []);
      })
      .catch((err) => {
        log(err);
      });

    getAll("hadithbook")
      .then((res) => {
        setBooks(res.rows || []);
      })
      .catch((err) => {
        log(err);
      });
  };

  // fetch content data
  const fetchContentToVerify = () => {
    setAllData([]);
    setLoading(true);

    let queryParams = `?page=${currentPage}&size=${pageSize}`;

    if (filters.language) {
      queryParams += `&language=${filters.language}`;
    }

    if (filters.bookId) {
      queryParams += `&bookId=${filters.bookId}`;
    }

    getAll(`${moduleMain}/to-verify${queryParams}`)
      .then((res) => {
        setAllData(res.items || []);
        setTotalRowCount(res.totalItems || 0);
        setLoading(false);
      })
      .catch((err) => {
        log(err);
        setLoading(false);
        notifications.current.errorAlert(
          t("common.somethingWentWrong"),
          t("common.tryAgain")
        );
      });
  };

  useEffect(() => {
    fetchContentToVerify();
  }, [currentPage, pageSize, filters]);

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  // Function to insert Islamic phrase at cursor position
  const insertIslamicPhrase = (phraseKey) => {
    const phrase = ISLAMIC_PHRASES[phraseKey];
    if (!phrase) return;

    // Try to get the text field in multiple ways
    let textField = null;

    if (textFieldRef.current) {
      // Try different selectors to find the textarea
      textField =
        textFieldRef.current.querySelector("textarea") ||
        textFieldRef.current.querySelector('input[type="text"]') ||
        textFieldRef.current.querySelector(".MuiInputBase-input");
    }

    // If we found a text field and it has selection methods
    if (textField && typeof textField.selectionStart !== "undefined") {
      const start = textField.selectionStart || 0;
      const end = textField.selectionEnd || 0;
      const beforeText = editedText.substring(0, start);
      const afterText = editedText.substring(end);

      // Add space before and after if needed
      const needSpaceBefore =
        beforeText.length > 0 && !beforeText.endsWith(" ");
      const needSpaceAfter = afterText.length > 0 && !afterText.startsWith(" ");

      const textToInsert = `${needSpaceBefore ? " " : ""}${phrase.arabic}${
        needSpaceAfter ? " " : ""
      }`;
      const newText = beforeText + textToInsert + afterText;

      setEditedText(newText);

      // Set cursor position after inserted text
      setTimeout(() => {
        const newPosition = start + textToInsert.length;
        textField.setSelectionRange(newPosition, newPosition);
        textField.focus();
      }, 10);
    } else {
      // Fallback: just append to the end of the text
      const needSpace = editedText.length > 0 && !editedText.endsWith(" ");
      const textToInsert = `${needSpace ? " " : ""}${phrase.arabic} `;
      setEditedText(editedText + textToInsert);

      // Try to focus the text field
      setTimeout(() => {
        if (textField) {
          textField.focus();
          // Move cursor to end
          const newLength = (editedText + textToInsert).length;
          textField.setSelectionRange(newLength, newLength);
        }
      }, 10);
    }
  };

  // Generate audio function
  const generateAudio = async (text) => {
    console.log(
      "🎵 Starting audio generation for text:",
      text.substring(0, 100) + "..."
    );
    setIsGeneratingAudio(true);
    setAudioText(text);

    try {
      const apiEndpoint = `${process.env.REACT_APP_REST_ENDPOINT}/audio/generate`;
      console.log("📡 Making request to:", apiEndpoint);

      const response = await axios.post(
        apiEndpoint,
        { text },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      console.log("📥 Response received:", {
        status: response.status,
        headers: response.headers,
        dataType: typeof response.data,
        dataSize: response.data?.size || 0,
      });

      const audioBlob = response.data;

      if (!audioBlob) {
        throw new Error("No audio data received");
      }

      if (audioBlob.size === 0) {
        throw new Error("Received empty audio response");
      }

      if (!audioBlob.type.startsWith("audio/")) {
        console.warn("⚠️ Blob type is not audio:", audioBlob.type);
        const audioBlob2 = new Blob([audioBlob], { type: "audio/mpeg" });
        console.log("🔄 Converted blob type to audio/mpeg");
        setAudioBlob(audioBlob2);
      } else {
        setAudioBlob(audioBlob);
      }

      console.log("✅ Audio blob ready:", {
        size: audioBlob.size,
        type: audioBlob.type,
      });

      setIsGeneratingAudio(false);
      setIsMediaPlayerOpen(true);

      console.log("🎬 Opening media player...");
    } catch (error) {
      console.error("❌ Error generating audio:", error);

      if (error.response) {
        console.error("Response error:", {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers,
        });
      }

      log(error);
      setIsGeneratingAudio(false);
      notifications.current.errorAlert(
        "Failed to generate audio",
        `Error: ${error.message || "Unknown error"}`
      );
    }
  };

  // Event handlers
  const handleReviewClick = (dataIndex) => {
    const item = allData[dataIndex];
    setDataToReview(item);
    setEditedText(item.translation || "");
    setEditedConventionalId(
      item.Hadiths?.conventionalId || item.conventionalId || ""
    );
    // Initialize hadith status from the API data
    setEditedHadithStatus(item.Hadiths?.status || "sahih");
    setComments("");
    setStatus("approved");
    setIsReviewModalOpen(true);
  };

  const handleSaveHadithStatus = () => {
    if (!dataToReview) return;

    setIsSavingHadithStatus(true);

    patchData(`${moduleMain}/update-hadith-status/${dataToReview.id}`, {
      status: editedHadithStatus,
    })
      .then(() => {
        notifications.current.successAlert(
          "Hadith status updated successfully",
          ""
        );
        fetchContentToVerify();
        setIsSavingHadithStatus(false);
      })
      .catch((err) => {
        log(err);
        notifications.current.errorAlert(
          "Failed to update hadith status",
          "Please try again"
        );
        setIsSavingHadithStatus(false);
      });
  };

  const handleCloseReviewModal = () => {
    setIsReviewModalOpen(false);
    setDataToReview(null);
  };

  const handleTextChange = (e) => {
    setEditedText(e.target.value);
  };

  const handleConventionalIdChange = (e) => {
    setEditedConventionalId(e.target.value);
  };

  const handleHadithStatusChange = (e) => {
    setEditedHadithStatus(e.target.value);
  };

  const handleCommentsChange = (e) => {
    setComments(e.target.value);
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const handleFilterChange = (name, value) => {
    setFilters({
      ...filters,
      [name]: value,
    });
    setCurrentPage(0);
  };

  const handleSaveText = () => {
    if (!dataToReview) return;

    setIsSavingText(true);

    patchData(`${moduleMain}/update-text/${dataToReview.id}`, {
      text: editedText,
    })
      .then(() => {
        notifications.current.successAlert(t("common.updateSuccess"), "");
        fetchContentToVerify();
        setIsSavingText(false);
      })
      .catch((err) => {
        log(err);
        notifications.current.errorAlert(
          t("common.somethingWentWrong"),
          t("common.tryAgain")
        );
        setIsSavingText(false);
      });
  };

  const handleSaveConventionalId = () => {
    if (!dataToReview) return;

    setIsSavingConventionalId(true);

    // This would need a new API endpoint for updating conventional ID
    patchData(`${moduleMain}/update-conventional-id/${dataToReview.id}`, {
      conventionalId: editedConventionalId,
    })
      .then(() => {
        notifications.current.successAlert(
          "Conventional ID updated successfully",
          ""
        );
        fetchContentToVerify();
        setIsSavingConventionalId(false);
      })
      .catch((err) => {
        log(err);
        notifications.current.errorAlert(
          "Failed to update Conventional ID",
          "Please try again"
        );
        setIsSavingConventionalId(false);
      });
  };

  const handleApproveReject = () => {
    if (!dataToReview) return;

    setIsSaving(true);

    const approvalType = isStudent ? "student" : "teacher";

    patchData(`${moduleMain}/approve/${dataToReview.id}`, {
      approvalType,
      status,
      comments,
    })
      .then(() => {
        notifications.current.successAlert(
          status === "approved"
            ? t("common.approvalSuccess")
            : t("common.rejectionSuccess"),
          ""
        );
        setIsReviewModalOpen(false);
        fetchContentToVerify();
        setIsSaving(false);
      })
      .catch((err) => {
        log(err);
        notifications.current.errorAlert(
          t("common.somethingWentWrong"),
          t("common.tryAgain")
        );
        setIsSaving(false);
      });
  };

  const handleGenerateContent = () => {
    if (!dataToReview || !editedText.trim()) {
      notifications.current.errorAlert(
        "No text available",
        "Please ensure there is text content to generate audio from"
      );
      return;
    }

    generateAudio(editedText);
  };

  const handleCloseMediaPlayer = () => {
    setIsMediaPlayerOpen(false);
    setAudioBlob(null);
    setAudioText("");
  };

  // Render Islamic phrases toolbar - Compact version for main editor
  const renderCompactIslamicPhrasesToolbar = () => {
    // Most commonly used phrases for quick access
    const commonPhrases = [
      ["saww", "ﷺ"],
      ["as", "عليه السلام"],
      ["ra", "رضي الله عنه"],
      ["raFemale", "رضي الله عنها"],
      ["swt", "سبحانه وتعالى"],
      ["bismillah", "بسم الله"],
      ["alhamdulillah", "الحمد لله"],
      ["subhanallah", "سبحان الله"],
      ["allahuakbar", "الله أكبر"],
      ["inshallah", "إن شاء الله"],
      ["mashallah", "ما شاء الله"],
      ["astaghfirullah", "أستغفر الله"],
    ];

    return (
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{ fontWeight: "bold", color: "primary.main", mb: 1 }}
        >
          <FontAwesomeIcon icon="mosque" style={{ marginRight: "8px" }} />
          Quick Islamic Phrases
        </Typography>

        <Grid container spacing={1}>
          {commonPhrases.map(([key, arabicText]) => {
            const phrase = ISLAMIC_PHRASES[key];
            return (
              <Grid item xs={6} sm={4} md={3} lg={2} key={key}>
                <Tooltip
                  title={
                    <div>
                      <Typography variant="body2">
                        {phrase.description}
                      </Typography>
                      <Typography variant="caption">
                        {phrase.english}
                      </Typography>
                    </div>
                  }
                  placement="top"
                >
                  <Button
                    variant="outlined"
                    size="small"
                    fullWidth
                    onClick={() => insertIslamicPhrase(key)}
                    sx={{
                      textAlign: "center",
                      justifyContent: "center",
                      fontFamily: "Arial, sans-serif",
                      fontSize: "12px",
                      minHeight: "36px",
                      maxHeight: "36px",
                      border: "1px solid #e0e0e0",
                      padding: "4px 8px",
                      "&:hover": {
                        backgroundColor: "primary.light",
                        color: "white",
                        border: "1px solid #1976d2",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        textAlign: "center",
                        width: "100%",
                        overflow: "hidden",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: "bold",
                          direction: "rtl",
                          fontSize: "11px",
                          lineHeight: 1.2,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {arabicText}
                      </Typography>
                    </Box>
                  </Button>
                </Tooltip>
              </Grid>
            );
          })}
        </Grid>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 1, display: "block" }}
        >
          💡 Click any phrase to insert it at your cursor position in the
          translation text above
        </Typography>
      </Box>
    );
  };

  const renderReviewModal = () => {
    if (!dataToReview) return null;

    const bookName = dataToReview?.Hadiths?.book?.name || "N/A";
    const bookAuthor = dataToReview?.Hadiths?.book?.author || "N/A";
    const conventionalId =
      dataToReview?.Hadiths?.conventionalId ||
      dataToReview?.conventionalId ||
      "N/A";
    const systemId = dataToReview?.hadithId || dataToReview?.id || "N/A";
    const language = dataToReview?.language || "N/A";

    const studentInfo = dataToReview.studentApprover
      ? `${dataToReview.studentApprover.firstName || ""} ${
          dataToReview.studentApprover.lastName || ""
        }`.trim()
      : null;

    const teacherInfo = dataToReview.teacherApprover
      ? `${dataToReview.teacherApprover.firstName || ""} ${
          dataToReview.teacherApprover.lastName || ""
        }`.trim()
      : null;

    const studentComments = dataToReview.studentComments;
    const teacherComments = dataToReview.teacherComments;
    const hasExistingComments = studentComments || teacherComments;

    return (
      <Dialog
        open={isReviewModalOpen}
        onClose={handleCloseReviewModal}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h6">Hadith Translation Review</Typography>
            </Grid>
            <Grid item>
              <Stack direction="row" spacing={1} flexWrap="wrap">
                <Chip
                  label={`Book: ${bookName}`}
                  color="primary"
                  variant="outlined"
                  size="small"
                />
                <Chip
                  label={`System ID: ${systemId}`}
                  color="secondary"
                  variant="outlined"
                  size="small"
                />
                <Chip
                  label={`Conv. ID: ${conventionalId}`}
                  color="info"
                  variant="outlined"
                  size="small"
                />
                <Chip
                  label={`Status: ${editedHadithStatus}`}
                  color={editedHadithStatus === "sahih" ? "success" : "warning"}
                  variant="outlined"
                  size="small"
                  icon={
                    <FontAwesomeIcon
                      icon={
                        editedHadithStatus === "sahih"
                          ? "check-circle"
                          : "exclamation-triangle"
                      }
                    />
                  }
                />
              </Stack>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent dividers>
          {/* Hadith Information Card */}
          <Card variant="outlined" sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom color="primary.main">
                <FontAwesomeIcon
                  icon="book-open"
                  style={{ marginRight: "8px" }}
                />
                Hadith Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" color="text.secondary">
                    Book:
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {bookName}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" color="text.secondary">
                    Author:
                  </Typography>
                  <Typography variant="body1">{bookAuthor}</Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography variant="body2" color="text.secondary">
                    System ID:
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {systemId}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Conventional ID"
                    value={editedConventionalId}
                    onChange={handleConventionalIdChange}
                    size="small"
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <Button
                          size="small"
                          onClick={handleSaveConventionalId}
                          disabled={isSavingConventionalId}
                          startIcon={
                            isSavingConventionalId ? (
                              <CircularProgress size={16} />
                            ) : (
                              <FontAwesomeIcon icon="save" />
                            )
                          }
                        >
                          Save
                        </Button>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="hadith-status-label">
                      Hadith Status
                    </InputLabel>
                    <Select
                      labelId="hadith-status-label"
                      value={editedHadithStatus}
                      label="Hadith Status"
                      onChange={handleHadithStatusChange}
                    >
                      <MenuItem value="sahih">
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <FontAwesomeIcon
                            icon="check-circle"
                            style={{ color: "green", fontSize: "14px" }}
                          />
                          Sahih
                        </Box>
                      </MenuItem>
                      <MenuItem value="zaeef">
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <FontAwesomeIcon
                            icon="exclamation-triangle"
                            style={{ color: "orange", fontSize: "14px" }}
                          />
                          Zaeef
                        </Box>
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={handleSaveHadithStatus}
                    disabled={isSavingHadithStatus}
                    startIcon={
                      isSavingHadithStatus ? (
                        <CircularProgress size={16} />
                      ) : (
                        <FontAwesomeIcon icon="save" />
                      )
                    }
                    sx={{ mt: 1, width: "100%" }}
                  >
                    Save Status
                  </Button>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Typography variant="body2" color="text.secondary">
                    Language:
                  </Typography>
                  <Typography variant="body1">{language}</Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Tabs for Content and Tools */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              <FontAwesomeIcon icon="language" style={{ marginRight: "8px" }} />
              Translation Content
            </Typography>

            <TextField
              ref={textFieldRef}
              multiline
              rows={8}
              fullWidth
              variant="outlined"
              value={editedText}
              onChange={handleTextChange}
              margin="normal"
              label="Hadith Translation"
              helperText={`Word count: ${
                editedText.split(/\s+/).filter((word) => word.length > 0).length
              } | Character count: ${editedText.length}`}
              sx={{
                "& .MuiInputBase-root": {
                  fontFamily: "Arial, sans-serif",
                  fontSize: "16px",
                  lineHeight: 1.6,
                },
              }}
            />

            {/* Islamic Phrases Toolbar - Now directly below the text editor */}
            {renderCompactIslamicPhrasesToolbar()}

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={2}
              mb={3}
            >
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleSaveText}
                  disabled={isSavingText}
                  startIcon={
                    isSavingText ? (
                      <CircularProgress size={20} />
                    ) : (
                      <FontAwesomeIcon icon="save" />
                    )
                  }
                  sx={{ mr: 1 }}
                >
                  Save Translation
                </Button>

                {isTeacher && (
                  <Button
                    variant="outlined"
                    color="secondary"
                    size="small"
                    onClick={handleGenerateContent}
                    disabled={isGeneratingAudio || !editedText.trim()}
                    startIcon={
                      isGeneratingAudio ? (
                        <CircularProgress size={20} />
                      ) : (
                        <FontAwesomeIcon icon="microphone" />
                      )
                    }
                  >
                    {isGeneratingAudio ? "Generating..." : "Generate Audio"}
                  </Button>
                )}
              </Box>

              {dataToReview.audioProcessingStatus && (
                <Box>
                  <Chip
                    label={`Audio: ${dataToReview.audioProcessingStatus}`}
                    color={
                      dataToReview.audioProcessingStatus === "completed"
                        ? "success"
                        : dataToReview.audioProcessingStatus === "failed"
                        ? "error"
                        : dataToReview.audioProcessingStatus === "in_process"
                        ? "warning"
                        : "default"
                    }
                    size="small"
                    variant="outlined"
                  />
                </Box>
              )}
            </Box>
          </Box>

          {/* Previous Comments Section */}
          {hasExistingComments && (
            <Box sx={{ mt: 3 }}>
              <Divider sx={{ my: 3 }} />
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                <FontAwesomeIcon
                  icon="comments"
                  style={{ marginRight: "8px" }}
                />
                Previous Comments
              </Typography>
              <List>
                {studentComments && (
                  <ListItem
                    alignItems="flex-start"
                    sx={{
                      bgcolor: "rgba(25, 118, 210, 0.08)",
                      borderRadius: 1,
                      mb: 1,
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar sx={{ bgcolor: "primary.main" }}>
                        <FontAwesomeIcon icon="user-graduate" />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography variant="subtitle2">
                          Student: {studentInfo || "Unknown"}
                          {dataToReview.studentApprovalDate && (
                            <Typography
                              variant="caption"
                              display="block"
                              color="text.secondary"
                            >
                              {new Date(
                                dataToReview.studentApprovalDate
                              ).toLocaleDateString()}
                            </Typography>
                          )}
                        </Typography>
                      }
                      secondary={studentComments}
                    />
                  </ListItem>
                )}

                {teacherComments && (
                  <ListItem
                    alignItems="flex-start"
                    sx={{
                      bgcolor: "rgba(46, 125, 50, 0.08)",
                      borderRadius: 1,
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar sx={{ bgcolor: "success.main" }}>
                        <FontAwesomeIcon icon="chalkboard-teacher" />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography variant="subtitle2">
                          Teacher: {teacherInfo || "Unknown"}
                          {dataToReview.teacherApprovalDate && (
                            <Typography
                              variant="caption"
                              display="block"
                              color="text.secondary"
                            >
                              {new Date(
                                dataToReview.teacherApprovalDate
                              ).toLocaleDateString()}
                            </Typography>
                          )}
                        </Typography>
                      }
                      secondary={teacherComments}
                    />
                  </ListItem>
                )}
              </List>
            </Box>
          )}

          <Divider sx={{ my: 3 }} />

          {/* Approval Section */}
          <Card variant="outlined">
            <CardContent>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                <FontAwesomeIcon
                  icon={isStudent ? "user-graduate" : "chalkboard-teacher"}
                  style={{ marginRight: "8px" }}
                />
                {`${isStudent ? "Student" : "Teacher"} Approval`}
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel id="status-select-label">Decision</InputLabel>
                    <Select
                      labelId="status-select-label"
                      value={status}
                      label="Decision"
                      onChange={handleStatusChange}
                    >
                      <MenuItem value="approved">
                        <FontAwesomeIcon
                          icon="check-circle"
                          style={{ marginRight: "8px", color: "green" }}
                        />
                        Approve
                      </MenuItem>
                      <MenuItem value="rejected">
                        <FontAwesomeIcon
                          icon="times-circle"
                          style={{ marginRight: "8px", color: "red" }}
                        />
                        Reject
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Your Comments"
                    multiline
                    rows={3}
                    fullWidth
                    variant="outlined"
                    value={comments}
                    onChange={handleCommentsChange}
                    placeholder="Add your comments here (optional but recommended for rejections)"
                    margin="normal"
                  />
                </Grid>
              </Grid>

              {/* Additional Metadata */}
              <Box mt={2} p={2} sx={{ bgcolor: "grey.50", borderRadius: 1 }}>
                <Typography variant="caption" color="text.secondary">
                  <strong>Metadata:</strong> Version {dataToReview.version || 1}{" "}
                  | Created:{" "}
                  {dataToReview.createdAt
                    ? new Date(dataToReview.createdAt).toLocaleDateString()
                    : "N/A"}{" "}
                  | Last Updated:{" "}
                  {dataToReview.updatedAt
                    ? new Date(dataToReview.updatedAt).toLocaleDateString()
                    : "N/A"}
                  {dataToReview.lastEditedBy && (
                    <> | Last Edited By: User ID {dataToReview.lastEditedBy}</>
                  )}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </DialogContent>

        <DialogActions sx={{ p: 3 }}>
          <Button onClick={handleCloseReviewModal} color="inherit" size="large">
            Cancel
          </Button>
          <Button
            onClick={handleApproveReject}
            variant="contained"
            color={status === "approved" ? "success" : "error"}
            disabled={isSaving}
            startIcon={
              isSaving ? (
                <CircularProgress size={20} />
              ) : (
                <FontAwesomeIcon
                  icon={status === "approved" ? "check" : "times"}
                />
              )
            }
            size="large"
          >
            {isSaving
              ? "Processing..."
              : status === "approved"
              ? "Approve Translation"
              : "Reject Translation"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  // Enhanced Media Player Modal with custom audio player
  const renderMediaPlayerModal = () => {
    return (
      <Dialog
        open={isMediaPlayerOpen}
        onClose={handleCloseMediaPlayer}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          sx: {
            bgcolor: "#000",
            color: "white",
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#000",
            color: "white",
            borderBottom: "1px solid #333",
          }}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h6" sx={{ color: "white" }}>
                <FontAwesomeIcon
                  icon="volume-up"
                  style={{ marginRight: "8px" }}
                />
                Audio Player - Hadith Translation
              </Typography>
            </Grid>
            <Grid item>
              <IconButton
                onClick={handleCloseMediaPlayer}
                sx={{ color: "white" }}
                size="large"
              >
                <FontAwesomeIcon icon="times" />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent sx={{ p: 0, bgcolor: "#000", minHeight: "400px" }}>
          {isGeneratingAudio ? (
            <Box
              sx={{
                width: "100%",
                height: "400px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#000",
                color: "white",
              }}
            >
              <CircularProgress size={60} sx={{ mb: 3, color: "#1976d2" }} />
              <Typography variant="h6" sx={{ mb: 2, color: "white" }}>
                Generating Audio Content...
              </Typography>
              <Typography
                variant="body2"
                sx={{ textAlign: "center", maxWidth: "80%", color: "#ccc" }}
              >
                Please wait while we create your audio content. This may take a
                few moments.
              </Typography>
              <Box sx={{ width: "60%", mt: 3 }}>
                <Skeleton
                  variant="rectangular"
                  height={8}
                  sx={{ borderRadius: 1, bgcolor: "rgba(255,255,255,0.1)" }}
                />
              </Box>
            </Box>
          ) : (
            audioBlob && (
              <CustomAudioPlayer
                audioBlob={audioBlob}
                text={audioText}
                onClose={handleCloseMediaPlayer}
              />
            )
          )}
        </DialogContent>
      </Dialog>
    );
  };

  // Custom Audio Player Component with Video-like Text Display
  const CustomAudioPlayer = ({ audioBlob, text, onClose }) => {
    const [audioUrl, setAudioUrl] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [volume, setVolume] = useState(1);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const audioRef = useRef(null);

    useEffect(() => {
      if (audioBlob) {
        const url = URL.createObjectURL(audioBlob);
        setAudioUrl(url);

        return () => {
          URL.revokeObjectURL(url);
        };
      }
    }, [audioBlob]);

    useEffect(() => {
      const audio = audioRef.current;
      if (!audio) return;

      const handleLoadedMetadata = () => {
        setDuration(audio.duration);
      };

      const handleTimeUpdate = () => {
        setCurrentTime(audio.currentTime);
      };

      const handleEnded = () => {
        setIsPlaying(false);
        setCurrentTime(0);
      };

      const handleCanPlayThrough = () => {
        // Auto-play the audio when it's ready
        audio
          .play()
          .then(() => {
            setIsPlaying(true);
            console.log("🎵 Audio started playing automatically");
          })
          .catch((error) => {
            console.warn("⚠️ Auto-play prevented by browser:", error);
            // Auto-play was prevented, user will need to click play
          });
      };

      audio.addEventListener("loadedmetadata", handleLoadedMetadata);
      audio.addEventListener("timeupdate", handleTimeUpdate);
      audio.addEventListener("ended", handleEnded);
      audio.addEventListener("canplaythrough", handleCanPlayThrough);

      return () => {
        audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
        audio.removeEventListener("timeupdate", handleTimeUpdate);
        audio.removeEventListener("ended", handleEnded);
        audio.removeEventListener("canplaythrough", handleCanPlayThrough);
      };
    }, [audioUrl]);

    const togglePlayPause = () => {
      const audio = audioRef.current;
      if (!audio) return;

      if (isPlaying) {
        audio.pause();
        setIsPlaying(false);
      } else {
        audio
          .play()
          .then(() => setIsPlaying(true))
          .catch((error) => console.error("Error playing audio:", error));
      }
    };

    const handleSeek = (event) => {
      const audio = audioRef.current;
      if (!audio) return;

      const rect = event.currentTarget.getBoundingClientRect();
      const clickX = event.clientX - rect.left;
      const newTime = (clickX / rect.width) * duration;

      audio.currentTime = newTime;
      setCurrentTime(newTime);
    };

    const handleVolumeChange = (event, newValue) => {
      const audio = audioRef.current;
      if (!audio) return;

      const volumeValue = newValue / 100;
      setVolume(volumeValue);
      audio.volume = volumeValue;
    };

    const formatTime = (seconds) => {
      if (isNaN(seconds)) return "0:00";
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${secs.toString().padStart(2, "0")}`;
    };

    const progressPercentage =
      duration > 0 ? (currentTime / duration) * 100 : 0;

    const toggleFullscreen = () => {
      setIsFullscreen(!isFullscreen);
    };

    // Detect if text contains Arabic characters
    const isArabicText = text && /[\u0600-\u06FF]/.test(text);
    const textDirection = isArabicText ? "rtl" : "ltr";

    return (
      <Box
        sx={{
          bgcolor: "#000",
          color: "white",
          position: "relative",
          width: "100%",
          height: isFullscreen ? "100vh" : "70vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {audioUrl && (
          <audio
            ref={audioRef}
            src={audioUrl}
            preload="auto"
            style={{ display: "none" }}
          />
        )}

        {/* Video-like Content Area */}
        <Box
          sx={{
            flex: 1,
            position: "relative",
            background: `
              linear-gradient(135deg, 
                #f5f7fa 0%, 
                #c3cfe2 50%, 
                #e8f4f8 100%
              )
            `,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            // Reserve space for controls - important for preventing overlap
            paddingBottom: "120px", // Reserve space for controls overlay
          }}
        >
          {/* Decorative Background Pattern */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              opacity: 0.1,
              background: `
                radial-gradient(circle at 20% 80%, rgba(0,0,0,0.1) 0%, transparent 50%),
                radial-gradient(circle at 80% 20%, rgba(0,0,0,0.1) 0%, transparent 50%),
                radial-gradient(circle at 40% 40%, rgba(0,0,0,0.05) 0%, transparent 50%)
              `,
            }}
          />

          {/* Islamic Pattern Overlay */}
          <Box
            sx={{
              position: "absolute",
              top: "10%",
              right: "10%",
              width: "200px",
              height: "200px",
              opacity: 0.05,
              background: `
                conic-gradient(from 0deg, 
                  transparent, 
                  rgba(0,0,0,0.1), 
                  transparent, 
                  rgba(0,0,0,0.1), 
                  transparent
                )
              `,
              borderRadius: "50%",
              animation: isPlaying ? "rotate 20s linear infinite" : "none",
              "@keyframes rotate": {
                "0%": { transform: "rotate(0deg)" },
                "100%": { transform: "rotate(360deg)" },
              },
            }}
          />

          {/* Main Text Content - Fixed Height Container */}
          <Box
            sx={{
              width: "85%",
              maxWidth: "900px",
              height: "auto",
              maxHeight: isFullscreen
                ? "calc(100vh - 200px)"
                : "calc(70vh - 200px)", // Ensure it fits
              textAlign: "center",
              zIndex: 2,
              padding: "30px",
              background: "rgba(255, 255, 255, 0.95)",
              borderRadius: "20px",
              boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(255,255,255,0.8)",
              position: "relative",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {/* Text Container with Dynamic Font Sizing */}
            <Box
              sx={{
                position: "relative",
                animation: isPlaying
                  ? "textGlow 3s ease-in-out infinite alternate"
                  : "none",
                "@keyframes textGlow": {
                  "0%": {
                    textShadow: "0 0 20px rgba(25, 118, 210, 0.3)",
                    transform: "scale(1)",
                  },
                  "100%": {
                    textShadow: "0 0 30px rgba(25, 118, 210, 0.5)",
                    transform: "scale(1.02)",
                  },
                },
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {/* Header */}
              <Typography
                variant="h6"
                sx={{
                  color: "#1976d2",
                  mb: 2,
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  fontSize: "18px", // Fixed size for header
                  flexShrink: 0, // Prevent shrinking
                }}
              >
                <FontAwesomeIcon icon="mosque" />
                Hadith Translation
              </Typography>

              {/* Main Text with Dynamic Sizing */}
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    color: "#333",
                    lineHeight: 1.6,
                    fontFamily: isArabicText
                      ? "'Amiri', 'Scheherazade', serif"
                      : "'Roboto', 'Arial', sans-serif",
                    // Dynamic font sizing based on text length
                    fontSize: (() => {
                      const textLength = (text || "").length;
                      if (textLength < 100)
                        return isArabicText ? "32px" : "28px";
                      if (textLength < 200)
                        return isArabicText ? "26px" : "22px";
                      if (textLength < 300)
                        return isArabicText ? "22px" : "18px";
                      if (textLength < 500)
                        return isArabicText ? "18px" : "16px";
                      if (textLength < 800)
                        return isArabicText ? "16px" : "14px";
                      return isArabicText ? "14px" : "12px";
                    })(),
                    direction: textDirection,
                    fontWeight: isArabicText ? "400" : "300",
                    letterSpacing: isArabicText ? "1px" : "0.5px",
                    textAlign: textDirection === "rtl" ? "right" : "center",
                    position: "relative",
                    wordWrap: "break-word",
                    hyphens: "auto",
                    overflowWrap: "break-word",
                    maxHeight: "100%",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    "&::before": isPlaying
                      ? {
                          content: '""',
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background:
                            "linear-gradient(90deg, transparent 0%, rgba(25, 118, 210, 0.1) 50%, transparent 100%)",
                          animation: "textHighlight 4s ease-in-out infinite",
                          borderRadius: "8px",
                          "@keyframes textHighlight": {
                            "0%": { transform: "translateX(-100%)" },
                            "100%": { transform: "translateX(100%)" },
                          },
                        }
                      : {},
                  }}
                >
                  {text || "Loading hadith text..."}
                </Typography>
              </Box>

              {/* Audio Status Indicator */}
              {isPlaying && (
                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    color: "#1976d2",
                    flexShrink: 0, // Prevent shrinking
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      bgcolor: "#1976d2",
                      animation: "pulse 1.5s ease-in-out infinite",
                      "@keyframes pulse": {
                        "0%": { opacity: 0.3, transform: "scale(1)" },
                        "50%": { opacity: 1, transform: "scale(1.2)" },
                        "100%": { opacity: 0.3, transform: "scale(1)" },
                      },
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "500", fontSize: "12px" }}
                  >
                    Now Playing
                  </Typography>
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      bgcolor: "#1976d2",
                      animation: "pulse 1.5s ease-in-out infinite 0.3s",
                    }}
                  />
                </Box>
              )}
            </Box>

            {/* Decorative Elements - Smaller for long text */}
            <Box
              sx={{
                position: "absolute",
                top: "-8px",
                left: "-8px",
                width: "40px",
                height: "40px",
                background:
                  "linear-gradient(45deg, rgba(25, 118, 210, 0.1), rgba(25, 118, 210, 0.2))",
                borderRadius: "50%",
                opacity: 0.6,
              }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: "-10px",
                right: "-10px",
                width: "50px",
                height: "50px",
                background:
                  "linear-gradient(45deg, rgba(25, 118, 210, 0.1), rgba(25, 118, 210, 0.15))",
                borderRadius: "50%",
                opacity: 0.4,
              }}
            />
          </Box>

          {/* Fullscreen Toggle */}
          <IconButton
            onClick={toggleFullscreen}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              bgcolor: "rgba(0,0,0,0.3)",
              color: "white",
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.5)",
              },
            }}
          >
            <FontAwesomeIcon icon={isFullscreen ? "compress" : "expand"} />
          </IconButton>
        </Box>

        {/* Video-style Controls Overlay */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            background: "linear-gradient(transparent, rgba(0,0,0,0.8))",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {/* Progress Bar */}
          <Box
            sx={{
              height: 6,
              bgcolor: "rgba(255,255,255,0.2)",
              borderRadius: 3,
              cursor: "pointer",
              position: "relative",
            }}
            onClick={handleSeek}
          >
            <Box
              sx={{
                height: "100%",
                bgcolor: "#1976d2",
                borderRadius: 3,
                width: `${progressPercentage}%`,
                transition: "width 0.1s ease",
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  right: "-6px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "12px",
                  height: "12px",
                  bgcolor: "#fff",
                  borderRadius: "50%",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                },
              }}
            />
          </Box>

          {/* Control Bar */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* Left Controls */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <IconButton
                onClick={togglePlayPause}
                disabled={!audioUrl}
                sx={{
                  color: "white",
                  "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
                  "&:disabled": { color: "rgba(255,255,255,0.3)" },
                }}
              >
                <FontAwesomeIcon icon={isPlaying ? "pause" : "play"} />
              </IconButton>

              <Typography
                variant="body2"
                sx={{ color: "white", minWidth: "80px" }}
              >
                {formatTime(currentTime)} / {formatTime(duration)}
              </Typography>
            </Box>

            {/* Right Controls */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: "200px",
              }}
            >
              <FontAwesomeIcon
                icon="volume-down"
                style={{ color: "white", fontSize: "14px" }}
              />
              <Box sx={{ flexGrow: 1 }}>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={volume * 100}
                  onChange={(e) => handleVolumeChange(e, e.target.value)}
                  style={{
                    width: "100%",
                    height: "4px",
                    background: `linear-gradient(to right, #1976d2 0%, #1976d2 ${
                      volume * 100
                    }%, rgba(255,255,255,0.3) ${
                      volume * 100
                    }%, rgba(255,255,255,0.3) 100%)`,
                    outline: "none",
                    borderRadius: "2px",
                    cursor: "pointer",
                    appearance: "none",
                    backgroundColor: "transparent",
                  }}
                />
              </Box>
              <FontAwesomeIcon
                icon="volume-up"
                style={{ color: "white", fontSize: "14px" }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };

  // Prepare data for the table
  const tableData = allData.map((item) => []);

  const options = {
    search: true,
    download: true,
    print: true,
    viewColumns: true,
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    selectableRowsHideCheckboxes: true,
    sort: true,
    onChangePage: (currentPage) => {
      setCurrentPage(currentPage);
    },
    onChangeRowsPerPage: (numberOfRows) => {
      setPageSize(numberOfRows);
    },
    page: currentPage,
    count: totalRowCount,
    rowsPerPageOptions: [10, 25, 50, 100],
    rowsPerPage: pageSize,
    textLabels: {
      body: {
        noMatch: loading ? (
          <Box>
            <Skeleton className="my-4" />
            <Skeleton className="my-4" />
            <Skeleton className="my-4" />
          </Box>
        ) : (
          "No content found for verification"
        ),
      },
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "99vh",
        backgroundColor: "rgba(222, 223, 223, 0.3)",
      }}
    >
      <CssBaseline />

      {/* Header */}
      <Header />

      {/* Sider */}
      <Sider />

      {/* Content */}
      <Box component="main" sx={{ flexGrow: 2, p: 3 }} mt={10}>
        <div className="px-1 px-md-5">
          {/* Upper Section */}
          <div className="row mb-4">
            <div className="col-md-8">
              <h2 className="mt-3">
                <FontAwesomeIcon
                  icon={isStudent ? "user-graduate" : "chalkboard-teacher"}
                  style={{ marginRight: "12px", color: "#1976d2" }}
                />
                {isStudent
                  ? "Student Content Verification"
                  : "Teacher Content Verification"}
              </h2>
              <Typography variant="subtitle1" color="text.secondary">
                {isStudent
                  ? "Review and approve hadith translations as a student"
                  : "Review student-approved translations as a teacher"}
              </Typography>
            </div>
            <div className="col-md-4">
              <Card variant="outlined" className="mt-3">
                <CardContent>
                  <Typography variant="subtitle2" gutterBottom>
                    <FontAwesomeIcon
                      icon="filter"
                      style={{ marginRight: "8px" }}
                    />
                    Filters
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Language</InputLabel>
                        <Select
                          value={filters.language}
                          label="Language"
                          onChange={(e) =>
                            handleFilterChange("language", e.target.value)
                          }
                        >
                          <MenuItem value="">All Languages</MenuItem>
                          {languages.map((lang) => (
                            <MenuItem key={lang.code} value={lang.code}>
                              {lang.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Book</InputLabel>
                        <Select
                          value={filters.bookId}
                          label="Book"
                          onChange={(e) =>
                            handleFilterChange("bookId", e.target.value)
                          }
                        >
                          <MenuItem value="">All Books</MenuItem>
                          {books.map((book) => (
                            <MenuItem key={book.id} value={book.id}>
                              {book.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </div>
          </div>

          <div className="mt-4">
            <Paper elevation={2}>
              <MUIDataTable
                title={
                  <Box display="flex" alignItems="center">
                    <FontAwesomeIcon
                      icon="list-alt"
                      style={{ marginRight: "12px", color: "#1976d2" }}
                    />
                    {isStudent
                      ? "Translations Pending Student Approval"
                      : "Translations Pending Teacher Approval"}
                  </Box>
                }
                data={tableData}
                columns={columns}
                options={options}
              />
            </Paper>
          </div>
        </div>

        {/* Review Modal */}
        {renderReviewModal()}

        {/* Media Player Modal */}
        {renderMediaPlayerModal()}

        {/* Alerts */}
        <AlertM ref={notifications} />
      </Box>
    </Box>
  );
}

export default ContentVerificationMain;
